const spanStyle = { display: 'block', width: '100%' };

export { spanStyle };
